import { defer, Observable, Subject } from 'rxjs';
import { finalize } from 'rxjs/operators';

export function indicateLoading<T>(indicator: Subject<any>, setValue: any = true) {
  return (source: Observable<T>): Observable<T> =>
    source.pipe(
      indicateLoadingStart(indicator, setValue),
      finalize(() => indicateLoadingFinish(indicator)),
    );
}

export function indicateLoadingStart<T>(indicator: Subject<any>, setValue: any = true) {
  return (source: Observable<T>): Observable<T> => source.pipe(prepare(() => indicator.next(setValue)));
}

export function indicateLoadingFinish(indicator: Subject<any>): void {
  indicator.next(false);
}

function prepare<T>(callback: () => void) {
  return (source: Observable<T>): Observable<T> =>
    defer(() => {
      callback();
      return source;
    });
}
